import axios from 'axios';
import { apiCache } from './cache';

// Wrapper for axios with caching
export const cachedGet = async (url, options = {}) => {
  const { cache = true, cacheTTL = 300000 } = options; // 5 minutes default
  
  // Check cache first
  if (cache && apiCache.has(url)) {
    console.log(`Cache hit for: ${url}`);
    return apiCache.get(url);
  }
  
  // Make API call
  console.log(`Fetching from API: ${url}`);
  try {
    const response = await axios.get(url);
    
    // Store in cache
    if (cache) {
      apiCache.set(url, response.data, cacheTTL);
    }
    
    return response.data;
  } catch (error) {
    // If rate limited, try to return cached data even if expired
    if (error.response?.status === 429 && apiCache.has(url)) {
      console.warn('Rate limited, using stale cache');
      return apiCache.get(url);
    }
    throw error;
  }
};

// Clear cache for specific endpoint or all
export const clearCache = (url = null) => {
  if (url) {
    apiCache.delete(url);
  } else {
    apiCache.clear();
  }
};
